import * as React from "react"
import { StyleguideTokenPart, StyleguideTokenRow } from "../../../../../Shared/Hoppinger.Styleguide/Frontend"

type TokensColorsTypes = {
  colorName: string
  attributes: string
  description?: string
  hasBorder?: boolean
  hasSeparator?: boolean
}

const colorTokens: TokensColorsTypes[] = [
  { colorName: 'black', attributes: '#000000', description: '', hasSeparator: false },
  { colorName: 'white', attributes: '#FFFFFF', description: '', hasBorder: true, hasSeparator: true },

  { colorName: 'blue-100', attributes: '#E9F4FD', description: '', hasBorder: false, hasSeparator: false },
  { colorName: 'blue-200', attributes: '#253A79', description: 'Primary blue', hasBorder: false, hasSeparator: false },
  { colorName: 'blue-400', attributes: '#0D2058', description: '', hasBorder: false, hasSeparator: true },

  { colorName: 'orange-200', attributes: '#FF7802', description: '', hasBorder: false, hasSeparator: false },
  { colorName: 'orange-400', attributes: '#FA6C37', description: 'Primary orange', hasBorder: false, hasSeparator: true },
  
  { colorName: 'green-400', attributes: '#3CC689', description: '', hasBorder: false, hasSeparator: true },
]

// ---------- ---------- ---------- ---------- ---------- ----------
// ---------- ---------- ---------- ---------- ---------- ----------
// ---------- ----------  STYLEGUIDE RENDERER  ---------- ----------
// ---------- ---------- ---------- ---------- ---------- ----------
// ---------- ---------- ---------- ---------- ---------- ----------

export const TokensColors = () => (
  <StyleguideTokenPart hasExampleColumn={true} hasAttributeColumn={true}>
    {colorTokens.map((c) => {
      return (
        <StyleguideTokenRow
          key={c.colorName}
          code={`$${c.colorName}`}
          description={c.description}
          attributes={c.attributes}
          columnCount={3}
          hasSeparator={c.hasSeparator || false}
          hasExample={true}
        >
          <div
            className={`styleguide-token__color${c.hasBorder ? '--border' : ''} token-color--${c.colorName}`}
          />
        </StyleguideTokenRow>
      )
    })}
  </StyleguideTokenPart>
)
